import apiClient from './client';

// ===== BRANDS =====
export const getBrands = async () => {
  const response = await apiClient.get('/brands');
  return response.data;
};

export const getBrandById = async (id) => {
  const response = await apiClient.get(`/brands/${id}`);
  return response.data;
};

export const createBrand = async (data) => {
  const response = await apiClient.post('/brands', data);
  return response.data;
};

export const updateBrand = async (id, data) => {
  const response = await apiClient.put(`/brands/${id}`, data);
  return response.data;
};

export const deleteBrand = async (id) => {
  const response = await apiClient.delete(`/brands/${id}`);
  return response.data;
};

// ===== SIZES =====
export const getSizes = async () => {
  const response = await apiClient.get('/sizes');
  return response.data;
};

export const createSize = async (data) => {
  const response = await apiClient.post('/sizes', data);
  return response.data;
};

export const updateSize = async (id, data) => {
  const response = await apiClient.put(`/sizes/${id}`, data);
  return response.data;
};

export const deleteSize = async (id) => {
  const response = await apiClient.delete(`/sizes/${id}`);
  return response.data;
};

// ===== USE CASES =====
export const getUseCases = async () => {
  const response = await apiClient.get('/use-cases');
  return response.data;
};

export const createUseCase = async (data) => {
  const response = await apiClient.post('/use-cases', data);
  return response.data;
};

export const updateUseCase = async (id, data) => {
  const response = await apiClient.put(`/use-cases/${id}`, data);
  return response.data;
};

export const deleteUseCase = async (id) => {
  const response = await apiClient.delete(`/use-cases/${id}`);
  return response.data;
};

// ===== TILE TYPES =====
export const getTileTypes = async () => {
  const response = await apiClient.get('/tile-types');
  return response.data;
};

export const createTileType = async (data) => {
  const response = await apiClient.post('/tile-types', data);
  return response.data;
};

export const updateTileType = async (id, data) => {
  const response = await apiClient.put(`/tile-types/${id}`, data);
  return response.data;
};

export const deleteTileType = async (id) => {
  const response = await apiClient.delete(`/tile-types/${id}`);
  return response.data;
};

// ===== OPTIONAL CATEGORIES =====
export const getOptionalCategories = async (includeInactive = false) => {
  const response = await apiClient.get(`/optional-categories?include_inactive=${includeInactive}`);
  return response.data;
};

export const getCategoryWithOptions = async (id) => {
  const response = await apiClient.get(`/optional-categories/${id}`);
  return response.data;
};

export const createOptionalCategory = async (data) => {
  const response = await apiClient.post('/optional-categories', data);
  return response.data;
};

export const updateOptionalCategory = async (id, data) => {
  const response = await apiClient.put(`/optional-categories/${id}`, data);
  return response.data;
};

export const toggleCategoryActive = async (id) => {
  const response = await apiClient.patch(`/optional-categories/${id}/toggle`);
  return response.data;
};

export const deleteOptionalCategory = async (id) => {
  const response = await apiClient.delete(`/optional-categories/${id}`);
  return response.data;
};

// ===== CATEGORY OPTIONS =====
export const addCategoryOption = async (categoryId, data) => {
  const response = await apiClient.post(`/optional-categories/${categoryId}/options`, data);
  return response.data;
};

export const updateCategoryOption = async (optionId, data) => {
  const response = await apiClient.put(`/optional-categories/options/${optionId}`, data);
  return response.data;
};

export const deleteCategoryOption = async (optionId) => {
  const response = await apiClient.delete(`/optional-categories/options/${optionId}`);
  return response.data;
};

// ===== ACCESSORY CATEGORIES =====
export const getAccessoryCategories = async () => {
  const response = await apiClient.get('/accessory-categories');
  return response.data;
};

export const getAccessoryCategoryById = async (id) => {
  const response = await apiClient.get(`/accessory-categories/${id}`);
  return response.data;
};

export const createAccessoryCategory = async (data) => {
  const response = await apiClient.post('/accessory-categories', data);
  return response.data;
};

export const updateAccessoryCategory = async (id, data) => {
  const response = await apiClient.put(`/accessory-categories/${id}`, data);
  return response.data;
};

export const deleteAccessoryCategory = async (id) => {
  const response = await apiClient.delete(`/accessory-categories/${id}`);
  return response.data;
};

// ===== ACCESSORY ATTRIBUTES =====
export const getAccessoryAttributes = async () => {
  const response = await apiClient.get('/accessory-attributes');
  return response.data;
};

export const getAccessoryAttributesByCategory = async (categoryId) => {
  const response = await apiClient.get(`/accessory-attributes/category/${categoryId}`);
  return response.data;
};

export const createAccessoryAttribute = async (data) => {
  const response = await apiClient.post('/accessory-attributes', data);
  return response.data;
};

export const updateAccessoryAttribute = async (id, data) => {
  const response = await apiClient.put(`/accessory-attributes/${id}`, data);
  return response.data;
};

export const deleteAccessoryAttribute = async (id) => {
  const response = await apiClient.delete(`/accessory-attributes/${id}`);
  return response.data;
};
